<template>
  <div class="drawer-box">
    <h1 class="title" v-html="details.title"></h1>
    <div class="release-box">
      <div>发布时间：{{ details.createTime }}</div>
      <!-- <div>创建人：{{details.createUser}}</div> -->
      <div>创建人：{{ createName }}</div>
    </div>
    <div class="column">
      <span class="line"></span>
      <span style="vertical-align: middle">基本信息</span>
    </div>
    <div class="drawer-content">
      <div class="item" v-if="details.author">
        <div class="label">作者：</div>
        <span class="content">{{ details.author }}</span>
      </div>
      <div class="item">
        <span class="label">封面：</span>
        <img
          v-if="details.cover"
          class="content-img"
          v-lazy="$global.imgUrl + details.cover"
          alt=""
        />
        <span v-else class="content">无图</span>
      </div>
      <div class="item">
        <div class="label">分类：</div>
        <span class="content">{{ details.classificationName }}</span>
      </div>
      <div class="item">
        <span class="label">是否原创：</span>
        <span class="content">{{ details.originalType === 1 ? "否" : "是" }}</span>
      </div>
      <div class="item" v-if="details.originalType === 1">
        <span class="label">来源：</span>
        <span class="content">{{ details.source }}</span>
      </div>
      <div class="item" v-if="details.originalType === 1">
        <span class="label">来源发布时间：</span>
        <span class="content">{{ details.originalPublishTime.slice(0,10) }}</span>
      </div>
      <div class="item">
        <span class="label">关键词：</span>
        <span class="content">{{ details.keyword }}</span>
      </div>
      <div class="item" v-if="details.artSummary">
        <span class="label">摘要：</span>
        <span class="content" v-html="details.artSummary"></span>
      </div>
      <div class="item">
        <span class="label">正文：</span>
        <span class="content" v-html="details.content"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["articleId", "articleType"],
  created() {
    this.getEcho(this.articleId, this.articleType);
  },
  data() {
    return {
      details: {},
      createName: "",
    };
  },
  methods: {
    // 获取详情
    async getEcho(articleId, articleType) {
      const resp = await this.$apis.userServe.getEcho({
        articleId,
        articleType,
      });
      this.createName = resp.data.createUserName;
      this.details = resp.data.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-box {
  padding: 0 20px 20px;
  .title {
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
  }
  .release-box {
    margin: 10px 0 48px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
  }
  .column {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #3c3c3c;
    .line {
      margin-right: 14px;
      width: 4px;
      height: 16px;
      background: #4343c1;
    }
  }
  .drawer-content {
    margin-top: 25px;
    .item {
      display: flex;
      .label {
        margin-right: 15px;
        width: 100px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 30px;
      }
      .content {
        flex: 1;
        font-size: 14px;
        color: #000000;
        line-height: 30px;
        &::v-deep img, 
        &::v-deep video{
          max-width: 100% !important;
        }
        &::v-deep span {
          white-space: normal !important;
        }
      }
      .content-img {
        width: 86px;
        height: 100px;
      }
    }
  }
}
</style>